module.exports = __webpack_public_path__ + "static/media/auth-bg.0c7cf3ba.mp4";